<template>
  <nuxt-link class="link" :to="props.viewMoreUrl">
    <span class="text-white">
      <slot />
    </span>
    <i class="btn-line before:bg-white" />
  </nuxt-link>
</template>

<script lang="ts" setup>
interface Props {
  viewMoreUrl: string;
}

const props = defineProps<Props>();
</script>

<style scoped lang="scss">
.link {
  display: flex;
  background-color: transparent;
  border: 1px solid transparent;
  width: 117px;
  height: 30px;
  text-decoration: none;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  cursor: pointer;
  span {
    display: inline-block;
    position: relative;
    font-size: 14px;
    line-height: 24px;
    letter-spacing: 0.5px;
    text-align: center;
    padding-bottom: 2px;
  }
  &::before {
    background-color: transparent;
    content: '';
    height: 94%;
    position: absolute;
    top: 1px;
    left: 1px;
    -webkit-transform: scale(0, 1);
    transform: scale(0, 1);
    -webkit-transition: -webkit-transform 0.8s;
    transition: transform 0.8s;
    transition:
      transform 0.8s,
      -webkit-transform 0.8s;
    -webkit-transform-origin: right top;
    transform-origin: right top;
    width: 98%;
  }
  &:hover {
    &::before {
      -webkit-transform: scale(1, 1);
      transform: scale(1, 1);
      -webkit-transform-origin: left top;
      transform-origin: left top;
    }
    i::before {
      -webkit-animation: lineMovetoLeft 1s ease forwards;
      animation: lineMovetoLeft 1s ease forwards;
    }
  }
}
i {
  height: 1px;
  overflow: hidden;
  margin: auto;
  line-height: 1;
  position: absolute;
  top: 0;
  right: -20px;
  bottom: 0;
  width: 30px;
  &::before {
    content: '';
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
  }
}
@keyframes lineMovetoLeft {
  0% {
    width: 0;
  }
  100% {
    width: 100%;
  }
}
</style>
